import clsx from "clsx";
import { useEffect, useState } from "react";

import styles from "./login-card.module.css";

interface LoginCardProps {
  "data-testid"?: string;
  children?: React.ReactNode;
}

export default function LoginCard({
  children,
  "data-testid": testId = "login-card",
}: LoginCardProps) {
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    // Fade in the list on mount.
    setLoaded(true);
  }, []);

  return (
    <div data-testid={testId} className={styles.cardWrapper}>
      <div className={clsx(styles.card, { [styles.loaded]: loaded })}>
        {children}
      </div>
    </div>
  );
}
